import React, { forwardRef, useEffect, useState } from 'react';
import { FieldTypes } from 'utils/formUtils';
import _ from 'lodash';
import UserAPI from 'restAPI/UserAPI';
import { Form } from 'antd';
import BaseModalForm from 'components/BaseModalForm';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import Vocabulary, { getVocabulary } from 'components/Vocabulary';

export const UNASSIGNED = "Unassigned";
const ChangeOwner = forwardRef(({ finding, afterClose, onOk }, ref) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState();
  const initialOwner = finding.owner?.id;
  const [value, setValue] = useState(initialOwner);
  const featureFlags = useFeatureFlag();
  
  useEffect(() => {
    setLoading(true);
    const { promise, cancel } = UserAPI.getAll(finding.product?.id);
    promise.then(data => setUsers([...[{ value: UNASSIGNED, label: UNASSIGNED }], ...data.map(d => ({ value: d.id, label: d.displayName }))]), _.noop).finally(() => setLoading(false));
    return cancel;
  }, [finding.product]);

  const handleOnOk = async (data) => {
    let response = {
      ...data,
      ownerId: data.ownerId === UNASSIGNED ? null : data.ownerId,
      id: finding.id,
    }
    if(value !== initialOwner){
      await onOk(response);
    }
  }

  const fields = [
    {
      name: "ownerId",
      label: <Vocabulary name="owner"/>,
      type: FieldTypes.SELECT_WITH_ACTION,
      options: users,
      rules: [{
        required: true,
        message: <><Vocabulary name="owner"/> is required</>
      }],
      props: {
        onChange: (value) => setValue(value),
        autoFocus: true
      }
    },
    ...(value !== initialOwner || _.isNull(initialOwner) ? [{
      name: "notes",
      label: "Note",
      type: FieldTypes.TEXT_AREA,
      required: true,
      customLengthRule: {
      max: 1000,
      message: "Maximum length is 1000 characters"
      },
    }] : [])
  ]

  if (featureFlags.VERSIONS) {
    fields.push({
        label: "Apply to all unresolved versioned Findings",
        name: "applyToVersionFindings",
        type: FieldTypes.SWITCH,
        inline: true,
    });
  }

  return (
    <BaseModalForm
      ref={ref}
      afterClose={afterClose}
      initialValues={{
        ownerId: initialOwner,
        applyToVersionFindings: true
      }}
      loading={loading}
      title={`Change ${getVocabulary("owner")}`}
      onOk={handleOnOk}
      form={form}
      fields={fields}
    >
    </BaseModalForm>
  )
})


export default ChangeOwner;
